import { day, getBrandClassName, perc } from "../../utilities/Utils"
import { getContacts } from "../../api/axios"
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import LoadingContainer from "../../components/LoadingContainer";

const ContactsTable = ({ params = {} }) => {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [contacts, setContacts] = useState([]);

// https://www.robinwieruch.de/react-hooks-fetch-data/

const { auth } = useAuth(); 
const { email = '', idBrand = '0' } = params;

const getFullName = (contact) => {
  return `${contact?.first_name ?? ''} ${contact?.last_name ?? ''}`.trim();
};

const isActiveContact = (contact) => {
  return String(contact?.active ?? '') === '1';
};

useEffect(() => {

  const fetchData = async () => {
    
    setIsLoading(true);
    
    try {
      
      const data = await getContacts({
        props: {
          params: {
            email,
            idBrand,
            includeInactive: 1,
          },
        },
        auth,
      });
      setContacts(data.results);
      setError(null);

    } catch (error) {

      setError(error);
      setContacts([]);

    }

    setIsLoading(false);

  };

  fetchData();
    
}, [auth, email, idBrand]);

  
  const hasContacts = Array.isArray(contacts) && contacts.length > 0;

  return (

    <LoadingContainer isLoading={isLoading}>
          
      <table className="table table--enhanced table--wide contacts-table">
                      
        <thead>
            <tr>
                <td>ID / Marca</td> 
                <td>Contacto</td> 
                <td className="c">Activo</td> 
                <td className="c">Fecha Alta</td> 
                <td className="c">Fecha Baja</td> 
                <td className="c">Envios</td> 
                <td className="c">Abiertos</td> 
                <td className="c">Clicks</td> 
                <td className="c">Historial</td> 
            </tr>
        </thead>
        <tbody>
            {error && (
              <tr>
                <td colSpan="9" className="c loading">
                  No se pudo cargar el listado de destinatarios
                  {error?.response?.data?.message ? `: ${error.response.data.message}` : ''}
                </td>
              </tr>
            )}
            {!isLoading && !error && !hasContacts && (
              <tr><td colSpan="9" className="c loading">No se encontraron resultados</td></tr>
            )}
            {!isLoading && hasContacts && contacts.map( item => {
              const fullName = getFullName(item);
              const isActive = isActiveContact(item);

              return (
              <tr key={item.id} className={!isActive ? 'inactive' : '' }>
                  
                  <td className="contacts-table__recipient-cell">
                    <div className="contacts-table__identity">
                      <Link className="vinculo table-id-pill" to={`/contacts/${item.id}/email-timeline`}>
                        {item.id}
                      </Link>
                      {item.brand_name ? (
                        <span className={getBrandClassName(item.brand_name, 'table-brand-label')}>
                          {item.brand_name}
                        </span>
                      ) : null}
                    </div>
                  </td>
                  <td className="contacts-table__contact-cell">
                    {fullName ? <span className="contacts-table__name">{fullName}</span> : null}
                    <span className="contacts-table__email">{item.email}</span>
                  </td>
                  <td className="c">
                    <span className={`contacts-table__status ${isActive ? 'contacts-table__status--active' : 'contacts-table__status--inactive'}`}>
                      {isActive ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td className="c">{day(item.fechaAlta || item.created_at)}</td>
                  <td className="c">{day(item.fechaBaja)}</td>
                  <td className="c">
                    <span className="contacts-table__metric">
                      <strong>{item.sent ?? 0}</strong>
                      <span>envíos</span>
                    </span>
                  </td>
                  <td className="c">
                    <span className="contacts-table__metric">
                      <strong>{item.opened ?? 0}</strong>
                      <span>{perc(item.sent,item.opened)}</span>
                    </span>
                  </td>
                  <td className="c">
                    <span className="contacts-table__metric">
                      <strong>{item.clicks ?? 0}</strong>
                      <span>{perc(item.sent,item.clicks)}</span>
                    </span>
                  </td>
                  <td className="c">
                    <Link className="vinculo contacts-table__history-link" to={`/contacts/${item.id}/email-timeline`}>
                      Ver historial
                    </Link>
                  </td>
                  
              </tr>
              );
            })}
            
        </tbody>

      </table>
    </LoadingContainer>
    
    )
}

export default ContactsTable
